import { useState } from "react";

type Status = "idle" | "loading" | "success" | "error";

const SUBMIT_ADDR = "https://readdy.ai/api/form/dahaqqjoh653ivfvnq20";

export default function SubscribeForm() {
  const [status, setStatus] = useState<Status>("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get("website_alt") ?? "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("订阅成功，我们会把每日精选更新发送到你的邮箱。");
      form.reset();
      return;
    }

    formData.delete("website_alt");

    setStatus("loading");
    setMessage("");

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.meta?.detail || parsed?.message || responseText || "";
      const isOk = response.ok && parsed?.code === "OK";
      const isSpam = /spam/i.test(serverMsg);

      if (isOk && !isSpam) {
        setStatus("success");
        setMessage("订阅成功，我们会把每日精选更新发送到你的邮箱。");
        form.reset();
      } else {
        setStatus("error");
        setMessage(serverMsg || "提交未能完成，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，提交没有成功，请检查网络后重试。");
    }
  };

  return (
    <form
      id="gua-subscribe-form"
      data-readdy-form
      onSubmit={handleSubmit}
      className="w-full"
    >
      <div className="flex flex-col gap-3 sm:flex-row">
        <div className="flex flex-1 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-3">
          <i className="ri-mail-line text-base text-foreground-500" />
          <input
            type="email"
            name="email"
            required
            placeholder="输入邮箱，订阅每日瓜料精选"
            className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
          />
        </div>
        <input
          type="text"
          name="website_alt"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
          className="field-aux-note"
        />
        <button
          type="submit"
          disabled={status === "loading"}
          className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-60"
        >
          {status === "loading" ? "提交中…" : "免费订阅"}
        </button>
      </div>
      {message && (
        <p
          className={`mt-3 flex items-start gap-2 text-sm ${
            status === "error" ? "text-primary-700" : "text-accent-800"
          }`}
        >
          <i className={status === "error" ? "ri-error-warning-line" : "ri-checkbox-circle-line"} />
          <span>{message}</span>
        </p>
      )}
      <p className="mt-3 text-xs text-foreground-500">
        每天固定时段汇总当天最重要的几条更新，不发送无关推广。
      </p>
    </form>
  );
}